import Header from '../components/Header';
import Footer from '../components/Footer';
import { useParams } from 'react-router-dom';

const NewsArticle = () => {
  const { slug } = useParams();
  
  return (
    <div className="min-h-screen bg-regal-dark">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">
              News Article: {slug}
            </h1>
            <p className="text-xl text-gray-400">
              This page will be created later.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NewsArticle;

